/**
 * ACORDE — <acorde-sigue-variante>: vuelve a pintar su contenido cuando el cliente cambia de variante.
 *
 * Horizon no vuelve a pintar toda la sección al cambiar de tamaño: cada pieza escucha el evento
 * `productSelect` de su sección, recibe la sección recién renderizada (`detail.html`) y actualiza
 * solo su parte. Este elemento hace eso para cualquier bloque propio: busca en el HTML nuevo el
 * elemento con el mismo `data-block-id` y copia sus hijos con `morph` (sin parpadeo).
 */
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class AcordeSigueVariante extends HTMLElement {
  connectedCallback() {
    this.seccion = this.closest('.shopify-section, dialog');
    if (!this.seccion) return;
    this.seccion.addEventListener(StandardEvents.productSelect, this.alElegir);
  }

  disconnectedCallback() {
    this.seccion?.removeEventListener(StandardEvents.productSelect, this.alElegir);
  }

  alElegir = (evento) => {
    if (!(evento.target instanceof Element) || evento.target.closest('product-card')) return;
    evento.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;
        const nuevo = html.querySelector(`acorde-sigue-variante[data-block-id="${this.dataset.blockId}"]`);
        if (nuevo) morph(this, nuevo, { childrenOnly: true });
      })
      .catch(() => {
        // Si la petición falla, Horizon ya avisa; aquí no hay nada que deshacer.
      });
  };
}

if (!customElements.get('acorde-sigue-variante')) {
  customElements.define('acorde-sigue-variante', AcordeSigueVariante);
}
